import { Reducer } from 'redux'
import { DeliveryAddressAction } from '../types/deliveryAddress-types';
import { AddressModel } from '../../models/address-model';
import { ZipCodeResponseModel }  from '../../models/address-model';
import DELIVERYADDRESS_CONSTANTS from '../constants/deliveryAddress-constants';


export interface AddressReducerState {
    loading: boolean;
    errorMessage?: string;
    success?: boolean;
    errorStatus?: boolean;
    successMessage?: string;
    zipCodeResponse?: ZipCodeResponseModel[];
    addressResponse?: AddressModel;
}

const initialState: AddressReducerState = {
    loading: false,
    errorMessage: "",
    success: false,
    errorStatus: false,
    successMessage: "",
    zipCodeResponse: [] as ZipCodeResponseModel [],
    addressResponse: {} as AddressModel
}

export const addAddressReducer: Reducer<AddressReducerState, DeliveryAddressAction> = (state = initialState, action: any) => {
    let errorMessage = "ERROR";
    switch (action.type) {

        /////***** VERIFY ZIP *****/////
        case DELIVERYADDRESS_CONSTANTS.ADDADDRESS_BEGIN:
            return {
                ...state,
                loading: true,
                success: false,
                errorStatus: false
            };

        case DELIVERYADDRESS_CONSTANTS.ADDADDRESS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                successMessage: action.data.response
            };
        
        case DELIVERYADDRESS_CONSTANTS.ADDADDRESS_ERROR:
            errorMessage = "ERROR";
            if (action.error && (action.error.data || action.error.message)) {
                errorMessage = action.error.data.error ?? action.error.message;
            }
            return {
                ...state,
                loading: false,
                success: false,
                errorStatus: true,
                errorMessage
            };

        /////***** GET ADDRESS *****/////  
        case DELIVERYADDRESS_CONSTANTS.GETADDRESS_BEGIN:
            return {
                ...state,
                loading: true,
                success: false,
                errorStatus: false
            };

        case DELIVERYADDRESS_CONSTANTS.GETADDRESS_SUCCESS:
            return {
                ...state,
                loading: false,
                addressResponse: action.data
            };
            
        case DELIVERYADDRESS_CONSTANTS.GETADDRESS_ERROR:
            errorMessage = "ERROR";
            if (action.error && (action.error.data || action.error.message)) {
                errorMessage = action.error.data.error ?? action.error.message;
            }
            return {
                ...state,
                loading: false,
                success: false,
                errorStatus: true,
                errorMessage
            };
        
         /////***** VERIFY ZIP *****/////   
        case DELIVERYADDRESS_CONSTANTS.VERIFYZIP_BEGIN:
            return {
                ...state,
                loading: true,
                success: false,
                errorStatus: false
            };

        case DELIVERYADDRESS_CONSTANTS.VERIFYZIP_SUCCESS:
            return {
                ...state,
                loading: false,
                success: false,
                errorStatus: false,
                zipCodeResponse: action.data
            };

        case DELIVERYADDRESS_CONSTANTS.VERIFYZIP_ERROR:
            errorMessage = "ERROR";
            if (action.error) {
                errorMessage = action.error.data.message;
            }
            return {
                ...state,
                loading: false,
                success: false,
                errorStatus: true,
                errorMessage
            };

        case DELIVERYADDRESS_CONSTANTS.DELIVERYADDRESS_CLEAR:
            return {
                loading: false,
                success: false,
                errorStatus: false,
                zipCodeResponse: [],
                addressResponse: {}
            };

        default:
            return state;
    }
}